import React from 'react';
import { View } from 'react-native';
import { Checkbox } from '@hmsexp/component-library';
import isFunction from 'lodash/isFunction';

const CheckBoxCell = ({ row, isHeaderCell, column }) => {
  if (isHeaderCell) {
    const isChecked = column?.isAllSelected || false;
    const checkboxValue = isChecked ? ['all'] : [];

    const handleCheckboxChange = (selectedOptions) => {
      const isSelected = selectedOptions.includes('all');
      if (isFunction(column?.handleAllSelectCb)) {
        column.handleAllSelectCb(isSelected);
      }
    };

    return (
      <View>
        <Checkbox
          onChange={handleCheckboxChange}
          options={[{ label: '', value: 'all' }]}
          values={checkboxValue}
        />
      </View>
    );
  }

  // For regular row cell
  const feedbackId = `${row?.id || ''}`;
  const isChecked = row?.isSelected || false;
  const checkboxValue = isChecked ? [feedbackId] : [];

  const handleCheckboxChange = (selectedOptions) => {
    const isSelected = selectedOptions.includes(feedbackId);
    if (isFunction(row?.onSelectClick)) {
      row.onSelectClick(row, isSelected);
    }
  };

  return (
    <View>
      <Checkbox
        onChange={handleCheckboxChange}
        options={[{ label: '', value: feedbackId }]}
        values={checkboxValue}
      />
    </View>
  );
};

export default CheckBoxCell;